import { render, staticRenderFns } from "./GestionDesarchivoForm.vue?vue&type=template&id=68714552&"
import script from "./GestionDesarchivoForm.vue?vue&type=script&lang=js&"
export * from "./GestionDesarchivoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports